module.exports = __webpack_public_path__ + "static/media/Vectoruser.c83168f0.svg";